export enum ETabBarSegments {
  Catalog = 'catalog',
  Favorites = 'favorites',
  Cabinet = 'cabinet',
  Home = 'home',
  Cart = 'cart',
  UnUsed = 'unUsed',
}
